export default __webpack_public_path__ + "8842b796fb03bed70dabf12591942339.png";